export const MainNavigationClicked = 'mainNavigation/clicked';
export const SubNavigationClicked = 'subNavigation/clicked';